import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { APP_NAME, RELEASE_VERSION, RELEASED_AT, formatReleaseDate } from '../config/release';

const About: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ maxWidth: 640, p: 3 }}>
        <Typography variant="h4" gutterBottom>
          About
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Use this page when support needs to confirm which release is currently loaded in the browser.
        </Typography>
        <Typography variant="overline" color="text.secondary">
          Application
        </Typography>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {APP_NAME}
        </Typography>
        <Typography variant="overline" color="text.secondary">
          Version
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {RELEASE_VERSION}
        </Typography>
        <Typography variant="overline" color="text.secondary">
          Released
        </Typography>
        <Typography variant="body1">{formatReleaseDate(RELEASED_AT)}</Typography>
      </Paper>
    </Box>
  );
};

export default About;
